import { render, staticRenderFns } from "./HousingAllowance.vue?vue&type=template&id=d01e2a64&scoped=true&"
import script from "./HousingAllowance.vue?vue&type=script&lang=js&"
export * from "./HousingAllowance.vue?vue&type=script&lang=js&"
import style0 from "./HousingAllowance.vue?vue&type=style&index=0&id=d01e2a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01e2a64",
  null
  
)

export default component.exports